export default __webpack_public_path__ + "static/media/away.562cf1ae.svg";